SlideView = require("views/slide")

class RevealView extends SlideView
  template: require("./template")

  events:
    "iostap .btn-reveal": "toggleContent"
    "iostap .btn-done": "submit"

  serialize: ->
    data = super
    data.hasPrompt = true
    data.isInternetExplorer = navigator.userAgent.indexOf('MSIE') isnt -1 or navigator.appVersion.indexOf('Trident/') > -1
    return data

  show: (ms = 300) ->
    @listenTo this, "resize", () ->
      @resetButtons
    @setEl(@findAll(".btn-reveal"), "buttons")
    @selectedIndexes = []

  refresh: (params) ->
    for { description }, i in params.data.content
      changed = i if @options.data.content[i]?.description isnt description

    super

    @selectedIndexes = []
    @resetButtons(changed)

  resetButtons: (activeIndex) ->
    @setEl(@findAll(".btn-reveal"), "buttons")

    if activeIndex?
      el = @getEl("buttons").item(activeIndex)
      @transition el, "none", true
      el.classList.add "active"

    for el, i in @getEl("buttons")
      el.style.height = ""
      el.offsetHeight
      @transition el, ""

  resizeButtons: ->
    height = _.reduce @getEl("buttons"), (m, el) ->
      Math.max(el.offsetHeight, el.firstChild.firstChild.offsetHeight, m)
    , 0

    el.style.height = "#{height}px" for el in @getEl("buttons")

  toggleContent: (e) ->
    el = e.currentTarget
    index = el.dataset.index

    @selectedIndexes = _.uniq(@selectedIndexes.concat(index))

    if @selectedIndexes.length is @serialize().content.length
      @setState("touched")

    if @options.data.focus
      for other in @getEl("buttons") when other isnt el
        other.classList.remove("active")

    el.classList.toggle("active")

module.exports = RevealView
